import React from 'react';
import { Button, Container, Grid, Typography } from '@mui/material';
import topImg from '../../../Img/banerOnlineBuh.jpg'
import InfoCard from '../Components/InfoCard';
import Segments from '../../Components/Segments';

const cardColor = ['rgb(144, 202, 249)', 'rgb(179, 157, 219)', 'rgb(255, 229, 127)', 'rgb(46 125 50 / 57%)']

const titleCard = ['МОБИЛЬНАЯ БУХГАЛТЕРИЯ', 'СЧЕТ/АВР/НАКЛАДНАЯ', 'РАСЧЕТ НАЛОГОВ', 'УЧЕТ РАСХОДОВ']

const captionsCard = ['доступность 24/7', 'создать за 1 мин', 'рассчитать ФНО 910/913', 'посчитать зарплату']

const text_segment_1 = [
    'Управляйте своими финансами в любое время и из любой точки мира. Все, что вам нужно – это доступ к интернету.',
    'Забудьте о ручной обработке документов и отчетов. Наша система автоматизирует большинство рутинных задач, позволяя вам сосредоточиться на стратегическом развитии бизнеса.',
    'Мы обеспечиваем высокий уровень защиты ваших финансовых данных с использованием передовых технологий шифрования и хранения.',
    'Наша платформа легко интегрируется с любой учетной системой имеющей API, CRM и ERP-системами, что обеспечивает полную синхронизацию данных и удобство работы.',
    'Использование онлайн бухгалтерии позволяет сократить затраты на содержание штатных бухгалтеров и избежать дополнительных расходов на программное обеспечение.',
]

const text_segment_1_bold = [
    'Доступность 24/7 - ',
    'Автоматизация процессов - ',
    'Безопасность данных - ',
    'Интеграция с другими системами - ',
    'Экономия времени и ресурсов - ',
]

const text_segment_2 = [
    'Наша онлайн бухгалтерия идеально подходит для:',
    'Предприниматели и владельцы небольших компаний, которым требуется эффективное управление финансами без лишних затрат на штатных бухгалтеров.',
    'Компании среднего размера, стремящиеся автоматизировать бухгалтерские процессы и повысить точность финансового учета.',
    'Бизнесы, работающие по упрощенной системе налогообложения, для которых важна простота и оперативность ведения учета.',
    'Предприятия, применяющие режим розничного налога, которым необходимы удобные инструменты для учета и отчетности.',
]

const text_segment_2_bold = [
    '',
    'Малого бизнеса: ',
    'Среднего бизнеса: ',
    'Компаний на Упрощённой системе налогообложения: ',
    'Компаний на режиме розничного налога: ',
]

const text_segment_3 = [
    'Наша онлайн бухгалтерия создана для того, чтобы сделать финансовое управление простым и доступным для каждого бизнеса.',
    'Магазины и торговые точки, нуждающиеся в быстрой и точной системе для учета доходов и расходов.',
    'Арендодатели, которым требуется простое решение для управления финансовыми потоками и налоговой отчетностью.',
    'Салоны красоты, автомастерские, клининговые компании и другие предприятия сферы услуг, стремящиеся к оптимизации бухгалтерских процессов.',
    'Кафе, рестораны и другие заведения, которым важно поддерживать порядок в бухгалтерии и отчетности.',
]

const text_segment_3_bold = [
    '',
    'Розничная торговля: ',
    'Сдача в аренду жилья и помещений: ',
    'Услуги и сервис: ',
    'Общественное питание: ',
]

const text_segment_4 = [
    'Ведение бухгалтерии самостоятельно может быть простой и эффективной задачей с использованием нашей системы онлайн бухгалтерии. Вот как вы можете легко управлять своими финансовыми делами:',
    'Создайте учетную запись на нашей платформе, указав основные данные о вашей компании. Настройте систему под ваши нужды, заполните Справочники: Товар/Услуга, Контрагенты, Адреса доставки и т.д.',
    'Создавайте Заявки по реализации Товаров/Услуг, формируйте документы на основе их. Разделите ваши расходы на категории для удобного анализа и управления.',
    'Генерируйте необходимые бухгалтерские и налоговые отчеты автоматически, расчитайте необходимые к уплате налоги. Система создаст их в соответствии с требованиями законодательства. Перенесите все данные в форму Кабинета налогоплательщика и отправьте отчет.',
    'Загрузите обработанный скан Подписи и Печати, это позволит вам с мобильного устройства отправлять готовые документы.',
]

const text_segment_4_bold = [
    '',
    'Регистрация и настройка - ',
    'Учет доходов и расходов - ',
    'Создание и отправка отчетов - ',
    'Электронная подпись и печать -  ',
]

const OnlineBuhgalteriyaPage = () => {

    return <>
        <Container maxWidth="xl" sx={{ mt: { xs: 8, md: 20 } }}>
            <Grid container spacing={1} sx={{ justifyContent: 'center', borderBottom: 2, borderColor: '#fcbb42', borderBottomStyle: 'inset', pb: { xs: 2, md: 5 } }}>
                <Grid item md={12} lg={4}  >
                    <img alt='Online Бухгалтер' src={topImg} style={{ width: '100%', border: 5 }} />
                </Grid>
                <Grid item md={12} lg={8} >
                    <Typography variant="h1" fontStyle={'italic'} fontSize={{ xs: '1.5em', md: '2em' }} textAlign={'center'} color={'#5d5d5d'} sx={{ mt: { xs: 0.5, md: 2 } }} >
                        Мобильная бухгалтерия - Online Бухгалтер!
                    </Typography>
                    <Typography color={'#5d5d5d'} variant="body1" fontSize={{ xs: '0.8em', md: '1.1em' }} gutterBottom sx={{ textIndent: '5%', px: { xs: 2, md: 0 }, mt: 1 }} >
                        Online(Онлайн) бухгалтерия – это современное решение для ведения бухгалтерского учета, которое позволяет управлять всеми финансовыми операциями через интернет. Используя наши передовые технологии, вы получаете возможность автоматизировать рутинные задачи, сократить время на обработку данных и снизить вероятность ошибок.
                    </Typography>
                    <Grid container spacing={{ xs: 2, md: 5 }} sx={{px: { xs: 0, md: 15 }, mt: { xs: 0, md: 3 }}}>
                        {[0, 1, 2, 3].map((item) => (
                            <Grid key={item} item xs={6} >
                                <InfoCard title={titleCard[item]} captions={captionsCard[item]} cardColor={cardColor[item]} logoCard={item} />
                            </Grid>
                        ))}
                    </Grid>
                </Grid>
                <Button sx={{mt: 2}} color='secondary' variant="outlined" onClick={()=>window.open('https://cabinet.finup.kz/', '_blank')} >Регистрация</Button>
            </Grid>
            <Container maxWidth="xl" sx={{ mt: 5, p: { xs: 'default', md: 0 } }}>
            <Grid container spacing={5} sx={{ justifyContent: 'center', borderBottom: 2, borderColor: '#fcbb42', borderBottomStyle: 'inset', pb: 3 }}>
                {/* <Grid item md={12} lg={12} sx={{ justifyContent: 'center' }} >
                    <Typography variant="h3" fontStyle={'italic'} fontSize={{ xs: '1.5em', md: '2em' }} textAlign={'center'} color={'#5d5d5d'} sx={{ mt: { xs: 0.5, md: 2 } }} >
                        Сегменты бухгалтерского управления:
                    </Typography>
                </Grid> */}
                <Grid item md={12} lg={12}  >
                    <Segments title='Преимущества онлайн бухгалтерии' text={text_segment_1} textBold={text_segment_1_bold} imgIndex={4} />
                </Grid>
                <Grid item md={12} lg={12}  >
                    <Segments title='Кому подойдет?' text={text_segment_2} textBold={text_segment_2_bold} imgIndex={5} />
                </Grid>
                <Grid item md={12} lg={12}  >
                    <Segments title='Сферы применения' text={text_segment_3} textBold={text_segment_3_bold} imgIndex={6} />
                </Grid>
                <Grid item md={12} lg={12}  >
                    <Segments title='Как вести бухгалтерию самому?' text={text_segment_4} textBold={text_segment_4_bold} imgIndex={7} />
                </Grid>
            </Grid>
        </Container>
        </Container>
    </>
}

export default OnlineBuhgalteriyaPage;
